<template>
    <div class="nav-item-add-icon">
        <CompassIcon :icon="icon" size="small" />
    </div>
</template>

<script>
export default {
    props: {
        icon: {
            type: String,
            required: true,
        },
    },
};
</script>

<style>
.nav-item-add-icon {
    width: 20px;
    height: 20px;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: var(--spacing-1);
    background-color: var(--colors-sellsy-brand-primary-500-alpha10);
    color: var(--colors-common-text-primary-default);
}
</style>
